import { styled } from "goober";
import { useState } from "react";
import type { ConnectorStyle } from "../lib/routeConnectors";
import { MapChromeLink } from "./MapChrome";
import { Tooltip } from "./Tooltip";

const StyleLink = styled(MapChromeLink)`
  & svg {
    opacity: 0.3;
  }
  & .wire {
    d: path("M 2 4 C 4 4, 6 4, 8 4 C 8 7, 8 9, 8 12 C 10 12, 12 12, 14 12");
    transition: d 180ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  &[data-connector-state="loose"] .wire {
    d: path("M 2 4 C 4 4, 5 5, 6 6 C 7 7, 9 9, 10 10 C 11 11, 13 12, 14 12");
  }
  &[data-connector-state="tidy"][data-preview="true"] .wire {
    d: path("M 2 4 C 4 4, 5 5, 6 6 C 7 7, 9 9, 10 10 C 11 11, 13 12, 14 12");
  }
  &[data-connector-state="loose"][data-preview="true"] .wire {
    d: path("M 2 4 C 4 4, 6 4, 8 4 C 8 7, 8 9, 8 12 C 10 12, 12 12, 14 12");
  }
`;

export function MapConnectorStyleControl({
  connectorStyle,
  to,
}: {
  connectorStyle: ConnectorStyle;
  to: string;
}) {
  const [hovered, setHovered] = useState(false);
  const [previewSuppressed, setPreviewSuppressed] = useState(false);
  const label = `Connections: ${connectorStyle === "loose" ? "Loose" : "Tidy"}`;
  return (
    <Tooltip content={label}>
      <StyleLink
        to={to}
        aria-label={label}
        data-connector-state={connectorStyle}
        data-preview={hovered && !previewSuppressed ? "true" : undefined}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => {
          setHovered(false);
          setPreviewSuppressed(false);
        }}
        onMouseDown={() => setPreviewSuppressed(true)}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            className="wire"
            d="M 2 4 C 4 4, 6 4, 8 4 C 8 7, 8 9, 8 12 C 10 12, 12 12, 14 12"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </StyleLink>
    </Tooltip>
  );
}
